import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { UpdateMenuSet } from '@/pages/menu-managements/allocated-menus/service';
import { MenuManagementAllocatedMenuService } from '@/services/AllocatedMenu/MenuManagementAllocatedMenuService';

export type MenuManagementAllocatedMenuBulkCreateParams = {
  master_store_ids: number[];
  menu_sets: UpdateMenuSet[];
};

export const useMenuManagementBulkCreateAllocatedMenu = async (
  params: MenuManagementAllocatedMenuBulkCreateParams
): Promise<void> => {
  const menuManagementAllocatedMenuService =
    new MenuManagementAllocatedMenuService(getClient());
  try {
    return menuManagementAllocatedMenuService.bulkCreate(params);
  } catch (error) {
    // @ts-ignore TS2322
    errorHandler({ error });
  }
};
